import { Tables } from '../../../../../../modules/API/Tables/Tables'
import { ITableDataProvider } from '../../../../../../generic/universal-table/types/data-provider.types'
import { productTableAdapter } from '../adapters/productTable.adapter'
import {
  ProductCreatePayload,
  ProductUiRow,
  ProductUpdatePayload,
} from '../types/productTable.types'

export const productTableService: ITableDataProvider<
  ProductUiRow,
  ProductCreatePayload,
  ProductUpdatePayload
> = {
  getList: async (): Promise<ProductUiRow[]> => {
    const rows = await Tables.getProductList()
    return rows?.map(productTableAdapter.fromApi) ?? []
  },

  create: async (payload: ProductCreatePayload): Promise<ProductUiRow> => {
    const created = await Tables.createProduct(payload)
    return productTableAdapter.fromApi(created)
  },

  update: async (
    id: number | string,
    payload: ProductUpdatePayload
  ): Promise<ProductUiRow> => {
    const updated = await Tables.updateProduct(Number(id), payload)
    return productTableAdapter.fromApi(updated)
  },

  remove: async (id: number | string): Promise<void> => {
    await Tables.deleteProduct(Number(id))
  },
}
